
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 49 49"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"M25.536 12.103a2.755 2.755 0 1 1-5.51 0 2.755 2.755 0 0 1 5.51 0M41.202 39.428a2.755 2.755 0 1 1-5.51 0 2.755 2.755 0 0 1 5.51 0M10.052 39.489a2.756 2.756 0 1 1-5.511 0 2.756 2.756 0 0 1 5.51 0","fill":"#D0EFEC"}}),_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#234652","d":"M37.298 44.482a6.997 6.997 0 1 0-.73-12.303L25.578 13.043M4.767 32.714a6.996 6.996 0 1 0 11.019 5.52l22.068.048m-6.399-28.004a6.996 6.996 0 1 0-10.29 6.783L10.09 36.15M22.991 10.87a1.401 1.401 0 1 0 2.802 0 1.401 1.401 0 0 0-2.802 0Zm18.038 26.26a1.401 1.401 0 1 0-1.401 2.427 1.401 1.401 0 0 0 1.401-2.427ZM9.5 39.475A1.401 1.401 0 1 0 8.1 37.048 1.401 1.401 0 0 0 9.5 39.475Z"}})])
          )
        }
      }
    